{
  "version": 2,
  "displayInfo": {
    "description": "An open test basin with deep water and steady winds. Good for trying out the controls before heading somewhere real.",
    "difficulty": "beginner"
  },
  "defaultDepth": -300,
  "waves": {
    "sources": [
      {
        "amplitude": 0.4,
        "wavelength": 200,
        "direction": 0.8
      },
      {
        "amplitude": 0.15,
        "wavelength": 20,
        "direction": 0.8
      }
    ]
  },
  "wind": {
    "sources": [
      {
        "direction": 0.785
      }
    ]
  },
  "startPosition": [40, 710],
  "startingPortId": "bayview-harbor",
  "ports": [
    {
      "id": "bayview-harbor",
      "name": "Bayview Harbor",
      "position": [30, 680],
      "angle": 1.57
    },
    {
      "id": "shield-cove",
      "name": "Shield Cove",
      "position": [500, 1870],
      "angle": -1.57
    },
    {
      "id": "eastern-point",
      "name": "Eastern Point",
      "position": [1050, 2650],
      "angle": 0
    }
  ],
  "missions": [
    {
      "id": "first-voyage",
      "name": "First Voyage",
      "description": "Deliver supplies from Bayview Harbor to Shield Cove across the channel.",
      "type": "delivery",
      "sourcePortId": "bayview-harbor",
      "destinationPortId": "shield-cove",
      "prerequisites": {},
      "rewards": {
        "money": 100,
        "revealPorts": ["eastern-point"]
      }
    },
    {
      "id": "supply-run",
      "name": "Supply Run",
      "description": "Bring provisions back from Shield Cove to Bayview Harbor.",
      "type": "delivery",
      "sourcePortId": "shield-cove",
      "destinationPortId": "bayview-harbor",
      "prerequisites": {
        "completedMissions": ["first-voyage"]
      },
      "rewards": {
        "money": 150
      }
    },
    {
      "id": "long-haul",
      "name": "Long Haul",
      "description": "Transport cargo from Bayview Harbor around to the remote Eastern Point.",
      "type": "delivery",
      "sourcePortId": "bayview-harbor",
      "destinationPortId": "eastern-point",
      "prerequisites": {
        "completedMissions": ["supply-run"]
      },
      "rewards": {
        "money": 300
      }
    },
    {
      "id": "return-trip",
      "name": "Return Trip",
      "description": "Navigate back from Eastern Point to Bayview Harbor with the final delivery.",
      "type": "delivery",
      "sourcePortId": "eastern-point",
      "destinationPortId": "bayview-harbor",
      "prerequisites": {
        "completedMissions": ["long-haul"]
      },
      "rewards": {
        "money": 200
      }
    }
  ],
  "contours": [
    {
      "name": "Bay Island Shore",
      "height": 0,
      "controlPoints": [
        [355.5905782577893, 610.884661230437],
        [688.8781515194332, 468.8901524390393],
        [852.4549190631374, 105.76385125413628],
        [838.8781515194332, -331.1098475609607],
        [638.8781515194332, -631.1098475609606],
        [188.87815151943323, -781.1098475609606],
        [-261.12184848056677, -631.1098475609606],
        [-461.12184848056677, -331.1098475609607],
        [-511.12184848056677, 68.8901524390393],
        [-311.12184848056677, 468.8901524390393],
        [3.486245294338005, 629.5641407171762],
        [68.87815151943323, 518.8901524390395],
        [-11.121848480566769, 318.8901524390393],
        [-91.12184848056677, 118.8901524390393],
        [-111.12184848056677, -81.1098475609607],
        [188.87815151943323, -181.1098475609607],
        [488.87815151943323, -81.1098475609607],
        [468.87815151943323, 118.8901524390393],
        [388.87815151943323, 318.8901524390393],
        [308.87815151943323, 518.8901524390395]
      ]
    },
    {
      "name": "Great Shield Island Shore",
      "height": 0,
      "controlPoints": [
        [-584.462887091739, 1637.053023402415],
        [-633.2524091331031, 2018.7403334823066],
        [-294.18628583735165, 2098.1792159582274],
        [79.83373724933517, 2063.8786341095],
        [379.8337372493352, 2013.8786341095004],
        [677.0260050985471, 1913.8786341095004],
        [933.216518960144, 1867.261415820309],
        [979.8337372493356, 2213.8786341095],
        [1027.9620306691727, 2633.3952511625052],
        [402.34205742910854, 2619.2451875309366],
        [111.23978379297523, 2721.6367129843843],
        [93.64664742837658, 3028.8882611350596],
        [288.59764566273725, 3265.0310131811007],
        [630.0834117193049, 3279.5005645243896],
        [1033.5771504096606, 3039.282974980399],
        [979.8337372493356, 3413.8786341094997],
        [879.8337372493356, 3813.8786341094997],
        [679.8337372493356, 3863.8786341094997],
        [379.8337372493352, 3913.8786341094997],
        [79.83373724933517, 3963.8786341094997],
        [-220.16626275066483, 3913.8786341094997],
        [-520.1662627506648, 3863.8786341094997],
        [-720.1662627506648, 3813.8786341094997],
        [-820.1662627506648, 3413.8786341094997],
        [-870.1662627506648, 2813.8786341094997],
        [-870.1662627506648, 2213.8786341095],
        [-820.1662627506648, 1813.8786341095001]
      ]
    },
    {
      "name": "Beginner Islands inner shelf",
      "height": -155.3,
      "controlPoints": [
        [-752.4225826733605, -1004.0787866149094],
        [1434.2440852001164, -739.8565635177501],
        [1390.2378759696987, 3792.9674651643404],
        [-1352.7808227581006, 3637.0572385940636]
      ]
    },
    {
      "name": "Beginner islands outer shelf",
      "height": -300,
      "controlPoints": [
        [-1446.1662881509471, -2156.3465574180723],
        [2595.1560298842232, -1784.445728956608],
        [1785.2386701237015, 4232.0832113516735],
        [-1793.273728048314, 3975.8848628559967]
      ]
    },
    {
      "name": "Contour 6",
      "height": 20,
      "controlPoints": [
        [-162.9629601447973, -532.6162906722698],
        [581.9362523518308, -457.9129292773789],
        [722.8054481250537, -48.11165218069016],
        [268.00083952630655, -290.89753730802624],
        [-380.6698990670509, -101.47119603418366]
      ]
    },
    {
      "name": "Contour 7",
      "height": 20,
      "controlPoints": [
        [-640.6606242653818, 2402.134241342826],
        [-253.72494530073538, 2358.0826007635997],
        [-165.36819972455726, 3362.136528716606],
        [-438.47086882008966, 3534.8338041609536]
      ]
    }
  ],
  "trees": {
    "spacing": 35,
    "density": 0.75,
    "minElevation": 4,
    "maxElevation": 500
  }
}
